// extracted by css-extract-rspack-plugin
export default {"scrollButton":"scrollButton-xxwGFd","chevron":"chevron-uOUZ8z"};